import { PureComponent } from "react";

import { type IGridCellRenderProps } from "commonComponents/utilities/Grid/Grid.types";
import {
    GridColumnType,
    type IClientGridColumn,
} from "commonComponents/utilities/Grid/GridContainer.types";
import { RFILink, type RFILinkResponse } from "commonComponents/utilities/RFIs/RFILink";

class RfiCell extends PureComponent<IGridCellRenderProps<RFILinkResponse>> {
    render() {
        const { cellValue } = this.props;

        if (!cellValue) {
            return null;
        }

        return (
            <RFILink
                id={cellValue.id}
                linkedType={cellValue.linkedType}
                builderId={cellValue.builderId}
                jobId={cellValue.jobId}
                rfiCount={cellValue.rfiCount}
            />
        );
    }
}

export const columnRfi: IClientGridColumn<RFILinkResponse> = {
    columnType: GridColumnType.rfi,
    Cell: RfiCell,
};
